import { UserRoundPen } from "lucide-react";
import { AccountPageHeader } from "../AccountPageHeader";

export function EditProfileContent() {
  return (
    <AccountPageHeader
      description="account.editProfileDescription"
      icon={UserRoundPen}
      title="account.editProfile"
    />
  );
}
